import AssetLocationDetails from './AssetLocationDetails'

export default AssetLocationDetails
